import { $, $$ } from '@utils';
import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';

function init() {
  if (!$('[data-au-franchising-recommender]')) return;
  addEventListeners();
}

function addEventListeners() {
  franchisingDatalayer();
  initializeWidgetOnStep3();
}

function franchisingDatalayer() {
  const itemIdTitle = {
    start: 'Paso 1 Selección',
    dodo2: 'Paso 2 Qué desea',
    codo2: 'Paso 2 Experiencia',
    codo2exp: 'Paso 2 Alta dedicación',
    codo3: 'Paso 3 Dispones de capital',
    codo4: 'Capital disponible',
    step5: '',
    dodo3rentstation: 'Paso 3 Alquilar EESS',
    dodo3rentspace: 'Paso 3 Alquilar terreno',
    dodo3franchising: 'Paso 3 Franquiciar con Moeve',
    dodo3sellstation: 'Paso 3 Vender estación',
    dodo3sellspace: 'Paso 3 Vender terreno',
  };

  $$('[data-au-franchising-recommender] [data-au-recommender-hide]').forEach((option) => {
    const optionHide = option.dataset.auRecommenderHide,
      itemIdFirstHalf = itemIdTitle[optionHide],
      cardText = option.querySelector('p'),
      itemIdSecondHalf = cardText ? cardText.textContent : option.querySelector(':not([data-au-icon]').textContent,
      content_type = cardText ? 'clickCard' : option.classList.contains('au-button') ? 'clickBoton' : 'clickEnlace';
    const item_id =
      itemIdFirstHalf === ''
        ? removeAccentMarkAndUppercase(itemIdFirstHalf)
        : removeAccentMarkAndUppercase(`${itemIdFirstHalf}_${itemIdSecondHalf}`);
    option.addEventListener('click', () => {
      window.dataLayer.push({
        event: 'navigation',
        content_type,
        item_id,
      });
    });
  });

  $$('[data-au-franchising-recommender] [data-au-recommender-success-button]').forEach((button) => {
    button.addEventListener('click', () => {
      window.dataLayer.push({
        event: 'generate_lead',
        content_type: 'download',
        item_id: 'download_franquicias',
      });
    });
  });

  $$('[data-au-franchising-recommender] [data-au-recommender-submit-button]').forEach((button) => {
    button.addEventListener('click', () => {
      window.dataLayer.push({
        event: 'generate_lead',
        content_type: 'lead_generation',
        item_id: 'lead_generation_franquicias',
      });
    });
  });
}

/* funcion para inicializar widget de formularios */

function initializeWidgetOnStep3() {
  let lastClickedButton = null;

  $$('[data-au-franchising-recommender] [data-au-recommender-hide]').forEach((button) => {
    const formName = button.dataset.auRecommenderFormId;

    if (formName !== 'undefined') {
      button.addEventListener('click', () => {
        lastClickedButton = formName;

        const lastContainer = $('[data-au-recommender-content="dodo3"]');
        const innerBtn = lastContainer.querySelector('[data-au-recommender-trigger]');

        if (lastClickedButton === 'codo3capital') {
          innerBtn.dataset.auRecommenderShow = 'codo2capital';
        } else {
          innerBtn.dataset.auRecommenderShow = 'dodo2';
        }

        if (lastClickedButton && lastClickedButton !== 'end') {
          initializeWidget(lastClickedButton);
        } else if (lastClickedButton === 'end') {
          const container = button.closest('[data-au-franchising-recommender]');
          const form = container.querySelector('[data-au-recommender-form]');
          const mainImg = container.querySelector('[data-au-recommender-image]');
          const endView = container.querySelector('[data-au-recommender-end-negative]');

          form.classList.add('au-hide');
          mainImg.classList.remove('au-hide');
          endView.classList.remove('au-hide');

          const homeBtn = container.querySelector('[data-au-recommender-begin-btn]');
          if (homeBtn && !homeBtn.dataset.listenerAdded) {
            homeBtn.addEventListener('click', () => {
              const startView = container.querySelector('[data-au-recommender-content="start"]');

              endView.classList.add('au-hide');
              startView.classList.remove('au-hide');
              mainImg.classList.add('au-hide');
              form.classList.remove('au-hide');
              form.focus();
            });

            homeBtn.dataset.listenerAdded = 'true';
          }
        }
      });
    }
  });
}

/* script de inicializacion de widget de formulario */

function initializeWidget(formId) {
  const genericForm = (formName, consents) => (prefix) => {
    var lang = document.documentElement.getAttribute('lang');
    var urlPathBff = '/widgets/miscasos/pub/bff/';
    var selectorWidget = '#react-formulariogenerico';
    // eslint-disable-next-line no-undef
    formulariogenerico
      .new({
        widgetName: 'webcom-formulariogenerico',
        selector: selectorWidget,
        intl: lang,
        host: prefix,
        path: urlPathBff,
        ctx: {
          idFormulario: formName,
        },
        consent: consents,
      })
      .render();
  };

  // eslint-disable-next-line no-undef
  loadWidget('/widgets/webcom-formulariogenerico/webcom-formulariogenerico.min.js?v=20241212').then(
    genericForm(formId, {
      es: {
        public: {
          pathCasos: '/widgets/miscasos/pub',
          idChannel: 'd1e5065ab67f11e8969c02d79b364547',
          nameChannel: 'CEPSA.ES - FORM - OTRA - CONSULTA',
        },
      },
      en: {
        public: {
          pathCasos: '/widgets/miscasos/pub',
          idChannel: 'd1e5065ab67f11e8969c02d79b364547',
          nameChannel: 'CEPSA.ES - FORM - OTRA - CONSULTA',
        },
      },
      pt: {
        public: {
          pathCasos: '/widgets/miscasos/pub',
          idChannel: 'd1e5065ab67f11e8969c02d79b364547',
          nameChannel: 'CEPSA.ES - FORM - OTRA - CONSULTA',
        },
      },
    }),
  );
}

export default { init };
